<template lang="pug">
span
  v-menu(offset-y rounded="lg" max-width="640" :close-on-content-click="false" attach nudge-bottom="4" z-index="11")
    template(v-slot:activator="{ on, attrs }")
      v-btn.px-2.button-text-normal.button-filter.text-none(v-if="getSelectedOption()" outlined rounded height="28" v-bind="attrs" v-on="on")
          v-icon.mr-1(@click.stop="clear" size=13) $yzi-x-circle
          .text-xs.font-semibold {{ $t('date') }}
          .px-1.neutral400--text | 
          .text-xs.primary--text.font-medium {{ getDateText() }}
          v-icon.ml-1(size=16) $yzi-chevron-down
      v-btn.px-2.button-text-normal.border-dashed.button-filter(v-else outlined rounded height="28" v-bind="attrs" v-on="on")
        v-icon.mr-1(size=13) $yzi-plus-circle
        .text-xs.text-none.font-semibold {{ $t('date') }}
    .white
      v-row(no-gutters)
        v-col(cols="5")
          .d-flex
            v-radio-group.ma-0.flex-grow-1(v-model="radioGroup")
              template(v-for="option in options")
                v-radio.px-4.py-1.mt-2(:value="option.id")
                  template(v-slot:label)
                    .text-sm.font-normal.primary--text {{ option.name }}
                v-divider.basic300

            v-divider.basic300(vertical)
        v-col(cols="7")
          .pa-4
            .text-sm.font-semibold {{ getDateText() }}
          v-divider.basic300
          yc-date-picker.range-date-picker(:parentDate.sync="selectedDates" range :readonly="readonly")
</template>

<script>
import { DateTime } from 'luxon'

export default {
  props: {
    dates: {
      type: Array,
      required: false,
      default: () => []
    },
    initializeDate: {
      type: Boolean
    }
  },
  data: () => ({
    options: [
      { id: 'lastSeven', name: 'Last 7 days' },
      { id: 'lastThirty', name: 'Last 30 days' },
      { id: 'lastNinety', name: 'Last 90 days' },
      { id: 'thisWeek', name: 'This week' },
      { id: 'thisMonth', name: 'This month' },
      { id: 'thisYear', name: 'This year' },
      { id: 'lastWeek', name: 'Last week' },
      { id: 'lastMonth', name: 'Last month' },
      { id: 'custom', name: 'Custom' },
    ],
    radioGroup: null,
    selectedDates: null,
    readonly: true,
  }),
  mounted () {
    if (this.initializeDate) {
      this.setupDates()
      this.radioGroup = 'lastSeven'
    }
  },
  watch: {
    selectedDates (val) {
      this.$emit('onUpdateRange', this.getSelectedOption())
      if (!val) {
        this.$emit('update:dates', [])
        return
      }
      const datesStr = this.dates && this.dates.length > 0 ? this.dates.toString() : ''
      if (val.toString() !== datesStr) {
        let newValue = val
        if (!val[1]) {
          newValue = [val[0], val[0]]
        }
        newValue = newValue.sort()
        this.$emit('update:dates', newValue)
      }
    },
    radioGroup (val) {
      const now = DateTime.local()
      const dateFormat = 'yyyy-MM-dd'
      this.readonly = true
      switch (val) {
        case 'lastSeven': {
          const start = now.minus({ days: 6 })
          this.selectedDates = [start.toFormat(dateFormat), now.toFormat(dateFormat)]
          break
        }
        case 'lastThirty': {
          const start = now.minus({ days: 30 })
          this.selectedDates = [start.toFormat(dateFormat), now.toFormat(dateFormat)]
          break
        }
        case 'lastNinety': {
          const start = now.minus({ days: 90 })
          this.selectedDates = [start.toFormat(dateFormat), now.toFormat(dateFormat)]
          break
        }
        case 'thisWeek': {
          const start = now.startOf('week')
          const end = now.endOf('week')
          this.selectedDates = [start.toFormat(dateFormat), end.toFormat(dateFormat)]
          break
        }
        case 'thisMonth': {
          const start = now.startOf('month')
          const end = now.endOf('month')
          this.selectedDates = [start.toFormat(dateFormat), end.toFormat(dateFormat)]
          break
        }
        case 'thisYear': {
          const start = now.startOf('year')
          const end = now.endOf('year')
          this.selectedDates = [start.toFormat(dateFormat), end.toFormat(dateFormat)]
          break
        }
        case 'lastWeek': {
          const lastWeek = now.minus({ weeks: 1 })
          const lastWeekStart = lastWeek.startOf('week')
          const lastWeekEnd = lastWeek.endOf('week')
          this.selectedDates = [lastWeekStart.toFormat(dateFormat),lastWeekEnd.toFormat(dateFormat)]
          break
        }
        case 'lastMonth': {
          const lastMonth = now.minus({ months: 1 })
          const lastMonthStart = lastMonth.startOf('month')
          const lastMonthEnd = lastMonth.endOf('month')
          this.selectedDates = [lastMonthStart.toFormat(dateFormat),lastMonthEnd.toFormat(dateFormat)]
          break
        }
        case 'custom': {
          this.readonly = false
          break
        }
        default:
          break
      }
    }
  },
  methods: {
    getDateText () {
      if (this.selectedDates && this.selectedDates.length > 0) {
        const start = this.selectedDates[0]
        let end = this.selectedDates[1]
        if (!end) {
          end = start
        }
        const dateFormat = 'd MMM yyyy'
        const startDate = DateTime.fromFormat(start, 'yyyy-MM-dd').toFormat(dateFormat)
        const endDate = DateTime.fromFormat(end, 'yyyy-MM-dd').toFormat(dateFormat)
        return `${startDate} - ${endDate}`
      }
      return '-'
    },
    getSelectedOption () {
      return this.options.find(i => i.id === this.radioGroup) ?? null
    },
    clear () {
      this.clearData()
      this.$emit('update:filter', [])
    },
    clearData () {
      this.radioGroup = null
      this.selectedDates = null
    },
    setupDates () {
      const now = DateTime.local()
      const dateFormat = 'yyyy-MM-dd'
      const start = now.minus({ days: 6 })
      
      this.selectedDates = [start.toFormat(dateFormat), now.toFormat(dateFormat)]
    },
  }
}
</script>

<style lang="scss">
.button-filter {
  min-width: 0 !important;
  color: #848484 !important;
}

.range-date-picker {

  .v-date-picker-table .v-btn.v-date-picker-table__current {
    color: #333333 !important;
  }

  .v-date-picker-table .v-btn.v-btn--active {
    background-color: #EEEEEE !important;
    color: #333333 !important;
  }

  .v-date-picker-table .v-btn.v-btn--active.v-date-picker--first-in-range, .v-btn.v-btn--active.v-date-picker--last-in-range {
    background-color: #333333 !important;
    .v-btn__content {
      color: #ffffff;
    }
  }

  .v-date-picker-table .v-btn {
    font-weight: 500;
    font-size: 16px !important;
  }

  .v-date-picker-table__current {
    border: 2px solid black !important;
  }
}
</style>